import React from "react";
import { Button, ButtonProps } from "antd";
import styled, { css } from "styled-components";

interface CustomButtonProps extends ButtonProps {
  LeftIconEnabled?: boolean;
  RightIconEnabled?: boolean;
  LeftIcon?: any;
  RightIcon?: any;
  hasTitle?: boolean;
  customSize?: "XLarge" | "Large";
  customType?: "Primary" | "Secondary" | "Link" | "Text";
  children?: any;
  onClickLeftIcon?: () => void;
  onClickRightIcon?: () => void;
}

const sizeStyles = css<{ customSize?: "XLarge" | "Large" }>`
  ${(props) =>
    props.customSize === "XLarge" &&
    css`
      height: 48px;
      width: 167px;
    `}
  ${(props) =>
    props.customSize === "Large" &&
    css`
      height: 40px;
      width: 167px;
    `}
`;

const typeStyles = css<{
  customType?: "Primary" | "Secondary" | "Link" | "Text";
}>`
  ${(props) =>
    props.customType === "Primary" &&
    css`
      border-radius: 4px;
      background: var(--Praimary-Blue-600, #2a60df);
      color: #ffffff;
      /* drop-shadow/button-primary */
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);

      &:hover {
        background: var(--Primary-Blue-500, #4583ec) !important;
        color: #ffffff !important;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
      }

      &:active {
        background: var(--Praimary-Blue-800, #2642a7) !important;
        color: #ffffff !important;
        /* drop-shadow/button-primary */
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
      }

      &:disabled {
        color: #c8c8c8 !important;
      }
    `}
  ${(props) =>
    props.customType === "Secondary" &&
    css`
      border-radius: 4px;
      border: 1px solid var(--Gray-500, #9e9e9e);
      background: var(--white, #fff);
      color: #545454;

      /* drop-shadow/button-secondary */
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);

      &:hover {
        border: 1px solid var(--Praimary-Blue-500, #4583ec);
        background: var(--white, #fff) !important;

        /* drop-shadow/button-secondary */
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
      }

      &:active {
        border: 1px solid var(--Praimary-Blue-800, #2642a7) !important;
        background: var(--white, #fff) !important;
        color: #2642a7 !important;
        /* drop-shadow/button-secondary */
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
      }

      &:disabled {
        color: #dfdfdf !important;
      }
    `}

    ${(props) =>
    props.customType === "Link" &&
    css`
      border-radius: 4px;
      border: none;

      color: #2a60df;

      &:hover {
        background: var(--Praimary-Blue-50, #f0f6fe) !important;
      }

      &:active {
        background: var(--Praimary-Blue-50, #f0f6fe) !important;
        color: #2642a7 !important;
      }

      &:disabled {
        color: #c8c8c8 !important;
      }
    `}

      ${(props) =>
    props.customType === "Text" &&
    css`
      border-radius: 4px;
      border: none;
      color: #545454;

      &:hover {
        background: var(--Gray--50, #f7f7f7) !important;
        color: #676767 !important;
      }

      &:active {
        background: var(--Gray--50, #f7f7f7) !important;
        color: #363636 !important;
      }

      &:disabled {
        color: #c8c8c8 !important;
      }
    `}
`;

const StyledButton = styled(Button)<{
  customSize?: "XLarge" | "Large";
  customType?: "Primary" | "Secondary" | "Link" | "Text";
}>`
  display: inline-flex;

  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  .left-icon {
    font-size: 16px;
  }

  .right-icon {
    font-size: 16px;
  }

  ${sizeStyles}
  ${typeStyles}

  .
`;

const CustomButton: React.FC<CustomButtonProps> = ({
  LeftIconEnabled,
  RightIconEnabled,
  LeftIcon,
  RightIcon,
  hasTitle,
  customSize,
  customType,
  children,
  onClickLeftIcon,
  onClickRightIcon,
  ...props
}) => {
  const handleIconClick = (event: React.MouseEvent, callback?: () => void) => {
    event.stopPropagation();
    if (callback) callback();
  };

  return (
    <StyledButton
      className="iran"
      {...props}
      customSize={customSize}
      customType={customType}
    >
      {RightIconEnabled && (
        <RightIcon
          className="icon right-icon"
          onClick={(e: any) => handleIconClick(e, onClickRightIcon)}
        />
      )}
      {hasTitle && children}
      {LeftIconEnabled && (
        <LeftIcon
          className="icon left-icon"
          onClick={(e: any) => handleIconClick(e, onClickLeftIcon)}
        />
      )}
    </StyledButton>
  );
};

export default CustomButton;
